module.exports = __webpack_public_path__ + "static/media/rvnb-web25.91669a35.jpg";